import {
  SHARE_DISPLAY_NAME_MAX_LENGTH,
  SHARE_DISPLAY_NAME_MIN_LENGTH,
  SHARE_DISPLAY_NAME_REGEX,
} from '../constants/meetings.constants'

/** What is wrong with a Screen Share display name. */
export type ShareNameProblem = 'NAME_REQUIRED' | 'NAME_TOO_SHORT' | 'NAME_TOO_LONG' | 'NAME_INVALID_CHARS'

/**
 * The name a Screen Share session will be shown under, checked the way the
 * backend checks it: trimmed, 2–50 characters, letters (any script), marks,
 * spaces and `. ' -`.
 *
 * The account's own name is never second-guessed. It is prefilled, it is who
 * the person already is everywhere else in the product, and refusing it over a
 * digit or a bracket the rule does not allow would leave someone unable to
 * share under their own name.
 */
export function shareDisplayNameProblem(value: string, accountName?: string | null): ShareNameProblem | null {
  const name = value.trim()
  if (!name) return 'NAME_REQUIRED'
  if (accountName && name === accountName.trim()) return null
  // Characters, not UTF-16 units: the backend counts code points, and a letter
  // outside the Basic Multilingual Plane (CJK Extension B, say) is two units.
  const length = Array.from(name).length
  if (length < SHARE_DISPLAY_NAME_MIN_LENGTH) return 'NAME_TOO_SHORT'
  if (length > SHARE_DISPLAY_NAME_MAX_LENGTH) return 'NAME_TOO_LONG'
  if (!SHARE_DISPLAY_NAME_REGEX.test(name)) return 'NAME_INVALID_CHARS'
  return null
}
